import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m300-440 131 131q11 12 11 28t-12 27q-12 12-28 12t-27-12L176-452q-11-11-11-28t11-28l200-199q11-12 27-12t28 11q12 12 12 29-1 16-12 28L300-520h473q17 0 29 12 11 11 11 28t-11 28q-12 12-29 12H300Z"/>',
  f: '<path d="m300-440 131 131q11 12 11 28t-12 27q-12 12-28 12t-27-12L176-452q-11-11-11-28t11-28l200-199q11-12 27-12t28 11q12 12 12 29-1 16-12 28L300-520h473q17 0 29 12 11 11 11 28t-11 28q-12 12-29 12H300Z"/>',
};

export default data;
